import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const rebuildList = function (list: any, isChild?: any) {
  let result = [];

  if (list) {
    result = list.concat();
    result.forEach((item: any, index: any) => {
      item._showChildren = true;
      item.isChild = !!isChild;
      item.isFirst = index === 0;
      item.isLast = index === result.length - 1;

      if (item.children) {
        item.children = rebuildList(item.children, true);
      }
    });
  }

  return result;
};

const URL = {
  LIST: '/dh-datamaint/cwSubject/list',
  ADD: '/dh-datamaint/cwSubject/add',
  DELETE: '/dh-datamaint/cwSubject/delete',
  DETAIL: '/dh-datamaint/cwSubject/getById',
  UPDATE: '/dh-datamaint/cwSubject/update',
  UPDATE_BASE_INFO: '/dh-datamaint/cwSubject/updateBaseInfo',
  MOVE: '/dh-datamaint/cwSubject/move'
};

class SubjectModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.LIST, { params: payload.data });
      return rebuildList(res.data.data);
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async UpdateBaseInfo(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE_BASE_INFO, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.MOVE, payload.data);
    }
  };
}

export const subjectModule = new SubjectModule();
